const init = () => {
    for (const el of document.querySelectorAll('[data-event-name]')) {
        el.addEventListener('click', function (event){
            if (window.analytics) {
                const target = event.currentTarget
                window.analytics.track(target.dataset.eventName, { label: target.dataset.eventLabel });
            }
        })
	}
}

export default {
    init
}